<template>
  <v-dialog
    v-model="isDialog"
    light
    persistent
    max-width="700"
  >
    <v-card v-if="isDialog">
      <div class="absX" @click.passive="closeDialog">
        <v-icon x-large class="myGray">mdi-window-close</v-icon>
      </div>
      <div class="pa-5 thisDialog text-center">
        <h3 class="mb-5">Wähle ein Bestellmodus:</h3>

        <div class="d-flex align-center justify-center">
          <div class="mobile pa-3">
            <OrderModeSwitcher
              @selected="closeDialog"
              :availableModes="availableOrderModes">
            </OrderModeSwitcher>
          </div>
          <div class="tablet pl-2 pr-2 pt-4 pb-7">
            <OrderModeSwitcher
              @selected="closeDialog"
              :availableModes="availableOrderModes">
            </OrderModeSwitcher>
          </div>
        </div>

<!--        <div class="mt-7">-->
<!--          <div class="d-flex justify-center">-->
<!--            &lt;!&ndash;            <v-btn @click="closeDialog" rounded depressed color="primary">&ndash;&gt;-->
<!--            &lt;!&ndash;              Cancel&ndash;&gt;-->
<!--            &lt;!&ndash;            </v-btn>&ndash;&gt;-->
<!--            <template v-if="userCode?.length>3">-->
<!--              &lt;!&ndash;              <div class="pl-2"></div>&ndash;&gt;-->
<!--              <v-btn @click="ok" rounded depressed color="primary">-->
<!--                Save-->
<!--              </v-btn>-->
<!--            </template>-->
<!--          </div>-->
<!--        </div>-->

      </div>
    </v-card>


  </v-dialog>
</template>


<script>
import store from "@/store/store";
import OrderModeSwitcher from "./OrderModeSwitcher.vue";

export default {
  props: {
    dialog: Boolean,
  },
  components: {
    OrderModeSwitcher,
  },
  data() {
    return {
      isDialog: false,

    }
  },
  computed: {
    availableOrderModes() {
      let modes = [];
      if (store.getters.enableInhouseOhnePay || store.getters.enableInhousePay) {
        modes.push('inhouse');
      }
      if (store.getters.enableTakwawayOhnePay || store.getters.enableTakeawayPay) {
        modes.push('takeAway');
      }
      if (store.getters.enableDeliveryOhnePay || store.getters.enableDeliveryPay) {
        modes.push('delivery');
      }
      return modes;
    },
  },
  watch: {
    dialog(newValue) {
      this.isDialog = newValue;
      if (newValue) {
        //init
        this.reset();
      }
    },
    isDialog(newValue) {
      if (!newValue) {
        // this.ready = false;
        this.$emit('close');
      }
    }
  },
  activated() {
    this.reset();
  },
  methods: {
    ok() {
      this.goAhead();
    },
    reset() {

    },
    closeDialog() {
      this.isDialog = false;
      // this.$emit('close');//no
    },
    goAhead() {
      this.closeDialog();
    },
    handleDismiss() {
      this.closeDialog();
    }
  },
}
</script>

<style lang="scss" scoped>

.thisDialog {
  min-height: 180px;
  padding-top: 30px !important;
}


</style>
